import Weekly from './Weekly';

export default Weekly;
